import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { QuotationService } from 'app/main/quotations/services/quotation.service';
import { Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import english from '../../../i18n/en.json';
import spanish from '../../../i18n/es.json';
import portuguese from '../../../i18n/pt.json';
var TabQuotationAttachmentsComponent = /** @class */ (function () {
    function TabQuotationAttachmentsComponent(quotationService, fuseTranslationLoaderService) {
        this.quotationService = quotationService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.reload = new Subject();
        this.removeSubscriptions = new Subject();
        this.isLoading = true;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    TabQuotationAttachmentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.reload
            .pipe(takeUntil(this.removeSubscriptions), tap(function () { return (_this.isLoading = true); }), switchMap(function () { return _this.getQuotationsAttachments(); }), tap(function () {
            _this.isLoading = false;
        }))
            .subscribe(function (page) { });
        this.reload.next();
    };
    TabQuotationAttachmentsComponent.prototype.getQuotationsAttachments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var quotationAttachments;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.quotationService.getAttachments(this.quotationId)];
                    case 1:
                        quotationAttachments = _a.sent();
                        this.quotationAttachments = {
                            attachments: quotationAttachments.attachments
                                .filter(function (attachment) { return attachment.archived === false; })
                                .map(function (attachment) { return (tslib_1.__assign({}, attachment, { isImage: _this.isAttachmentTypeImage(attachment) })); })
                        };
                        return [2 /*return*/];
                }
            });
        });
    };
    TabQuotationAttachmentsComponent.prototype.isAttachmentTypeImage = function (attachment) {
        if (attachment.type.indexOf('image/') >= 0 || attachment.type.indexOf('signature') >= 0) {
            return true;
        }
        return false;
    };
    TabQuotationAttachmentsComponent.prototype.getIconByAttachmentType = function (attachmentType) {
        if (attachmentType === 'application/pdf') {
            return 'icon-file-pdf';
        }
        if (attachmentType === 'application/msword') {
            return 'icon-file-word';
        }
        if (attachmentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            return 'icon-file-word';
        }
        if (attachmentType === 'application/vnd.ms-excel') {
            return 'icon-file-excel';
        }
        if (attachmentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            return 'icon-file-excel';
        }
        if (attachmentType === 'application/vnd.ms-powerpoint') {
            return 'icon-file-powerpoint';
        }
        if (attachmentType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
            return 'icon-file-powerpoint';
        }
        if (attachmentType === 'text/plain') {
            return 'icon-file-document';
        }
        if (attachmentType === 'text/csv') {
            return 'icon-file-delimited';
        }
        if (attachmentType === 'application/vnd.google-earth.kml+xml') {
            return 'icon-google-maps';
        }
        if (attachmentType.includes('video')) {
            return 'icon-file-video';
        }
        return 'icon-file';
    };
    return TabQuotationAttachmentsComponent;
}());
export { TabQuotationAttachmentsComponent };
